var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClik2PayLogoColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 79.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7b3bad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clik2pay_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clik2pay"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.09,48.54c0-9.75,7.09-17.35,17-17.35,7.53,0,13.93,4.31,15.76,12l-6,1.46A9.39,9.39,0,0,0,105.25,37c-6.4,0-10.7,5.06-10.7,11.52C94.55,55.19,99,60,105.31,60c4.81,0,8.68-2.91,9.56-7.54l6.08,1.4c-1.84,7.72-8.29,12-15.83,12C95,65.89,88.09,58.23,88.09,48.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.77,59.62h6.46V23.08h-6.46v-5.5H137.5v42h6.39v5.45H124.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.3,37.46h-6V32h12.28V65.07H151.3Zm-1-15.2a4.21,4.21,0,0,1,8.42,0,4.21,4.21,0,1,1-8.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.65,17.58h6.27V44.3h4.81L186.47,32h7.34L183.17,46.64v.51l11.34,17.92H187L177.92,50h-5V65.07h-6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.16,57.09,216.44,39.8c2-2.09,3.36-4.18,3.36-7,0-3.93-2.79-7-7.41-7-4.37,0-7.28,3.29-7.28,7.54h-6c0-6.46,4.49-13.49,13.42-13.49,8.61,0,13.74,6.21,13.74,12.73,0,4.68-2.15,7.66-4.88,10.51L205.3,58.73v.51h21.28v5.83H199.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234,32h6.15v4.56h.5a12.2,12.2,0,0,1,10.45-5.38c9.12,0,16,7.28,16,17.28s-6.46,17.42-15.52,17.42c-6.39,0-9.56-3.55-10.76-5.57h-.51V79.63H234Zm26.6,16.46c0-7-4.5-11.45-10.32-11.45-6.21,0-10.13,5.25-10.13,11.45,0,7.35,4.62,11.59,10.25,11.59C256.33,60.06,260.64,55.31,260.64,48.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.76,48.54c0-9.94,6.4-17.35,15.51-17.35A12.49,12.49,0,0,1,298,36.76h.5V32h6.27V57.85c0,1,.63,1.52,1.65,1.52h1.52v5.7h-4.5c-2.72,0-4.81-1.71-4.81-4.56h-.44a12,12,0,0,1-10.51,5.38C278.47,65.89,271.76,58.61,271.76,48.54Zm26.91.06C298.67,41.26,294,37,288.35,37c-5.89,0-10.26,4.81-10.26,11.58,0,7,4.56,11.53,10.33,11.53C294.68,60.13,298.67,54.87,298.67,48.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.35,73.93h4.24c2.66,0,4-1.14,4.94-3.48l2.09-5.38H322L310.26,32h6.84l8.67,27h.51l9.37-27h6.9L326.78,73.23c-1.71,4.44-5.19,6.4-10.25,6.4h-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.07,25.68h-1.93v-1.4h5.3v1.4h-1.9v6.2h-1.47Zm4.51-1.4h2.6l1.54,6.21h.12l1.61-6.21H360v7.6h-1.44v-6.2h-.12l-1.58,6.2h-2.13l-1.59-6.2H353v6.2h-1.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.72,27.82,11,29.8V16.46C11,4.7,21,0,29.64,0,41.07,0,47.8,7.06,47.8,15.17V21c0,13-10.23,14.49-19,16.71L19,40.24C12.42,41.91,6.65,44,6.65,51.6V73.77H45.56v5.86H0V51.19C0,38.11,10.23,36,19,33.71l9.77-2.54C35.42,29.46,41.23,27.65,41.23,21V15.17C41.23,10.46,37.75,6,29.72,6c-7.71,0-12,4-12,10.46Zm29.94,8c6.28,2.2,11.61,5.93,11.61,15.38V79.63H52.62v-28c0-5.74-3.26-8.33-7.69-10ZM34.71,53.75a5.08,5.08,0,1,0-8.4,3.83v7.48H33V57.58A5.06,5.06,0,0,0,34.71,53.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClik2PayLogoColour);
export default __webpack_public_path__ + "static/media/Clik2payLogoColour.9a0f859c236404d31eaa7c47cf562391.svg";
export { ForwardRef as ReactComponent };